const currencyFormatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
	minimumFractionDigits: 2,
});

const currency = amount => {
	const parsed = typeof amount === "string" ? parseFloat(amount) : amount;
	return typeof parsed === "number" && !Number.isNaN(parsed)
		? currencyFormatter.format(parsed)
		: amount;
};

export default currency;
